/**
 * OneTrophy - animations au scroll.
 * JS natif, aucune dependance. Les elements [data-ot-reveal] recoivent la classe "is-visible" a leur entree dans
 * l'ecran ; tout le rendu est gere en CSS (ot-theme.css). Sans JS, ou si l'utilisateur prefere reduire les
 * animations, le contenu reste simplement visible.
 */
(() => {
  const root = document.documentElement;
  window.otMotionReady = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduced || !('IntersectionObserver' in window)) {
    root.classList.remove('ot-motion');
    return;
  }

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -12% 0px', threshold: 0.08 });

  const observe = (scope) => scope.querySelectorAll('[data-ot-reveal]:not(.is-visible)').forEach((element) => observer.observe(element));

  observe(document);

  // Le theme editor recharge les sections a la volee : on rebranche l'observateur sur la section modifiee
  document.addEventListener('shopify:section:load', (event) => observe(event.target));

  // Parallax tres leger, reserve aux ecrans larges avec souris
  const parallaxItems = document.querySelectorAll('[data-ot-parallax]');

  if (parallaxItems.length > 0 && window.matchMedia('(min-width: 1000px) and (pointer: fine)').matches) {
    let ticking = false;

    const update = () => {
      parallaxItems.forEach((element) => {
        const rect = element.getBoundingClientRect();

        if (rect.bottom > 0 && rect.top < window.innerHeight) {
          const progress = (rect.top + rect.height / 2 - window.innerHeight / 2) / window.innerHeight;
          element.style.setProperty('--ot-parallax', `${(progress * Number(element.dataset.otParallax || 24)).toFixed(1)}px`);
        }
      });

      ticking = false;
    };

    window.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(update);
      }
    }, { passive: true });

    update();
  }
})();
